import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  getCustomFieldsDefinitionsError: {
    id: 'customFields.getUserCustomFields.error',
    defaultMessage:
      'Nie udało się pobrać danych pracownika w zakładce ”Pozostałe informacje”. Spróbuj odświeżyć stronę.',
  },
});
